import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Col, Container, Row } from "reactstrap"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import "@fullcalendar/bootstrap/main.css"
import "../../../assets/css/Work/digitalMarketing.css"
import Breadcrumb from "components/Common/Breadcrumb"
import { ResizableBox } from "react-resizable"
import Draggable from "react-draggable"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import moment from "moment"
import editEventImg from "../../../assets/images/Digital Marketing/editEventImg.jpg"
import { useSelector } from "react-redux"
import { fetchNodeData } from "utils/common-fetchData"
import {
  convertMinutesToTimeString,
  getInitials,
  getTimeDifferenceInMinutes,
} from "utils/common-helpers"
import configure from "configure"
import viewImg from "../../../assets/images/Inventory/viewImg.jpg"

const HrReport = props => {
  // meta title
  document.title = "Weekly Planning | Zithas Crm"
  const [events, setEvent] = useState([])
  const generalData = useSelector(state => state?.GeneralData?.generalData)
  const [modal, setModal] = useState(false)
  const [currentStatusPopup, setCurrentStatusPopup] = useState(false)
  const [selectedStaff, setSelectedStaff] = useState([])
  const [currentProject, setCurrentProject] = useState(false)
  const today = new Date()
  const firstDayPrevMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  )
  document.addEventListener("keydown", e => {
    if (e.key == "Escape") {
      if (currentStatusPopup) {
        setCurrentStatusPopup(false)
      }
      if (modal) {
        setModal(false)
      }
    }
  })

  const [isLoading, setLoading] = useState(false)
  const token = secureLocalStorage.getItem("auth_token")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [holidayDates, setHolidayDates] = useState([])
  const holidays = ["2025-06-05", "2025-06-09", "2025-06-11"]
  const [isSearch, setIsSearch] = useState(false)
  const [eventDetail, setEventDetail] = useState({})
  const [currentMonth, setCurrentMonth] = useState("")
  const [currentYear, setCurrentYear] = useState("")
  const [monthDetail, setMonthDetail] = useState({})
  const toggleLoading = loading => {
    setLoading(loading)
  }
  const onGetDetails = async currentMonth => {
    const res = await fetchNodeData(
      toggleLoading,
      `hrReport/${selectedStaff?.value}/${currentMonth}/${currentYear}`,
      token
    )
    if (res) {
      setMonthDetail(res?.data)
      setEvent(
        res?.data.report?.map(obj => ({
          start: obj?.date,
          end: obj?.date,
          extendedProps: {
            avatar: res?.data?.avatar,
            alias_name: res?.data?.alias_name,
            isHoliday: false,
            isLeave: obj?.leave,
            isHalfDay: false,
            isLatePunch: obj?.latePunch,
            totalHoursWorked: obj?.totalTimeInMinutes,
            expectedHours: obj?.taskDurationInMinutes,
            leaveType: obj?.leaveType,
            leaveStatus: obj?.leaveStatus,
          },
          ...obj,
        }))
      )
    }
  }

  useEffect(() => {
    if (selectedStaff?.length != 0 && isSearch) {
      onGetDetails(currentMonth)
    }
  }, [currentMonth, isSearch])

  const totalLeaves = events?.filter(
    item =>
      item.extendedProps.isLeave === true && !holidayDates.includes(item.date)
  )

  const totalDuration = events.reduce(
    (sum, task) => sum + Number(task.extendedProps.expectedHours),
    0
  )

  const leave_options = [
    { label: "Sick Leave", value: "1" },
    { label: "Earned Leave", value: "2" },
    { label: "Casual Leave", value: "3" },
  ]
  const [punchPair, setPunchPair] = useState([])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumb title="Human Resource" breadcrumbItem="Hr Report" />
          <div className="d-flex align-items-center col-md-11  global-cred">
            <div className="me-3 col-md-3">
              <Select
                placeholder="Select Staff"
                className="basic-multi-select "
                classNamePrefix="select"
                options={generalData?.staff}
                value={selectedStaff}
                onChange={e => {
                  setSelectedStaff(e)
                }}
              />
            </div>
            <button
              className="btn btn-sm  bg-purple text-white me-2"
              onClick={() => {
                onGetDetails(currentMonth)
                setIsSearch(true)
              }}
            >
              <i className="bi bi-funnel-fill fs-6"></i>
            </button>

            {isSearch ? (
              <div className="d-flex justify-content-start align-items-center gap-3 ms-3">
                <a className="text-purple fw-bold">
                  Total Working Hours :{" "}
                  {convertMinutesToTimeString(totalDuration) || "0"} Hrs{" "}
                </a>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span
                    className=" border-black"
                    style={{
                      padding: "6px",
                      backgroundColor: "rgb(193, 197, 255)",
                    }}
                  ></span>
                  <span>Holidays: {holidayDates?.length}</span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span
                    className=" border-black"
                    style={{
                      padding: "6px",
                      backgroundColor: "rgb(255, 200, 200)",
                    }}
                  ></span>
                  <span>Leaves: {totalLeaves?.length}</span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span>
                    Salary:{" "}
                    {`${
                      monthDetail?.salary != null
                        ? `${
                            Number(monthDetail?.salary).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) || 0
                          }`
                        : 0
                    }`}
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span>
                    EL:{" "}
                    {`${
                      monthDetail?.leaveBalance?.earned_leave != null
                        ? `${
                            Number(
                              monthDetail?.leaveBalance?.earned_leave
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }) || 0
                          }`
                        : 0
                    }`}
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span>
                    SL:{" "}
                    {`${
                      monthDetail?.leaveBalance?.sick_leave != null
                        ? `${
                            Number(
                              monthDetail?.leaveBalance?.sick_leave
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }) || 0
                          }`
                        : 0
                    }`}
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <span>
                    CL:{" "}
                    {`${
                      monthDetail?.leaveBalance?.casual_leave != null
                        ? `${
                            Number(
                              monthDetail?.leaveBalance?.casual_leave
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }) || 0
                          }`
                        : 0
                    }`}
                  </span>
                </div>
              </div>
            ) : null}
          </div>
          {isSearch ? (
            <div className="card p-4 h-100">
              <Row>
                <Col className="col-12 hr-report">
                  <Row>
                    <Col lg={12}>
                      <FullCalendar
                        plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
                          interactionPlugin,
                        ]}
                        initialDate={firstDayPrevMonth}
                        slotDuration={"00:15:00"}
                        handleWindowResize={true}
                        themeSystem="bootstrap"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth",
                        }}
                        events={events}
                        editable={false}
                        droppable={false}
                        selectable={false}
                        eventClick={info => {
                          const logs = info?.event?.extendedProps?.punchLogs
                          const result = []
                          for (let i = 0; i < logs?.length; i += 2) {
                            result.push({
                              punch_date: logs[i].punch_date,
                              punch_in: logs[i]?.punch_time || "",
                              punch_out: logs[i + 1]?.punch_time || "",
                            })
                          }
                          setPunchPair(result)
                          setEventDetail(info?.event?.extendedProps)
                          setCurrentProject(true)
                        }}
                        eventContent={arg => {
                          const { event } = arg
                          const {
                            isLeave,
                            isHalfDay,
                            isLatePunch,
                            totalHoursWorked,
                            expectedHours,
                            avatar,
                            alias_name,
                            leaveType,
                            leaveStatus,
                          } = event.extendedProps

                          const day = moment(event.start).day()
                          const date = moment(event.start).date()
                          const weekOfMonth = Math.ceil(date / 7)
                          const isSunday = day === 0
                          const isHolidaySaturday =
                            day === 6 &&
                            (weekOfMonth === 1 || weekOfMonth === 3)
                          const isHoliday = isSunday || isHolidaySaturday

                          if (isHoliday) {
                            return null // Don't render content for holidays
                          }

                          return (
                            <div className="d-flex flex-column justify-content-center align-items-start p-1">
                              <div className="d-flex align-items-center mb-1 text-black">
                                {avatar ? (
                                <img
                                  src={`${configure.imgUrl}${avatar}`}
                                  alt="User Icon"
                                  className="me-2"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                  }}
                                />
                                ) : (
                                  <div
                                    className="defualt-img me-2"
                                    title={alias_name}
                                    style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                  }}
                                    >{getInitials(alias_name || "Z")}
                                    </div>
                                )}
                                {isLeave
                                  ? "Staff is on Leave"
                                  : `Working Hours: ${convertMinutesToTimeString(
                                      expectedHours
                                    )}h`}{" "}
                              </div>
                              {isLeave ? (
                                <div className="mt-1 mb-1 text-black text-start text-capitalize">
                                  Leave Type:{" "}
                                  {
                                    leave_options?.find(
                                      obj => obj?.value == leaveType
                                    )?.label
                                  }{" "}
                                  <br />
                                  Leave Status : {leaveStatus || "UnInformed"}
                                </div>
                              ) : (
                                <>
                                  {totalHoursWorked != null &&
                                    expectedHours != null && (
                                      <div className="mt-1 mb-1 text-black text-start">
                                        Total Hours:{" "}
                                        {convertMinutesToTimeString(
                                          totalHoursWorked
                                        )}
                                        h
                                      </div>
                                    )}
                                  <div className="mt-1 d-flex flex-wrap gap-1">
                                    {isHalfDay && (
                                      <div className="badge bg-warning text-black">
                                        Half Day
                                      </div>
                                    )}
                                    {isLatePunch && (
                                      <div className="badge bg-danger text-black">
                                        Late Punch
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          )
                        }}
                        eventClassNames={arg => {
                          const { extendedProps, start } = arg.event

                          const date = moment(start)
                          const day = date.day() // 0 = Sunday, 6 = Saturday
                          const weekOfMonth = Math.ceil(date.date() / 7)

                          const isSunday = day === 0
                          const isFirstOrThirdSaturday =
                            day === 6 &&
                            (weekOfMonth === 1 || weekOfMonth === 3)
                          const isHoliday =
                            isSunday ||
                            isFirstOrThirdSaturday ||
                            extendedProps.isHoliday

                          if (isHoliday) {
                            return ["bg-transparent"]
                          }
                          if (extendedProps.isLeave) {
                            return ["bg-danger"]
                          }
                          return ["bg-success"]
                        }}
                        datesSet={arg => {
                          const { start, end } = arg
                          const holidays = []
                          const calendarMonth = moment(
                            arg.view.currentStart
                          ).format("MM")
                          const calendarYear = moment(
                            arg.view.currentStart
                          ).format("YYYY")
                          const current = moment(start)
                          while (current.isBefore(end)) {
                            const day = current.day() // 0 = Sunday, 6 = Saturday
                            const dateStr = current.format("YYYY-MM-DD")

                            if (day === 0) {
                              // Sunday
                              holidays.push(dateStr)
                            } else if (day === 6) {
                              // Saturday
                              const weekOfMonth = Math.ceil(current.date() / 7)
                              if (weekOfMonth === 1 || weekOfMonth === 3) {
                                holidays.push(dateStr) // 1st or 3rd Saturday
                              }
                            }

                            current.add(1, "day")
                          }
                          setHolidayDates(holidays)
                          setStartDate(moment(start).format("YYYY-MM-DD"))
                          setEndDate(moment(end).format("YYYY-MM-DD"))
                          setCurrentMonth(calendarMonth)
                          setCurrentYear(calendarYear)
                        }}
                        dayCellClassNames={arg => {
                          const dateStr = moment(arg.date).format("YYYY-MM-DD")
                          if (holidayDates.includes(dateStr)) {
                            return ["holiday-cell"]
                          }
                          if (holidays.includes(dateStr)) return ["leave-cell"]
                          return []
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="card p-4 h-100">
              <Row>
                <Col className="col-12 hr-report">
                  <Row className="justify-content-center">
                    <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                      <img src={viewImg} alt="Image" width={400} />
                      <p className="text-purple fw-bold text-center lh-base">
                        📊 All staff attendance data is now available <br />
                        use filters to efficiently search and analyze
                        company-wide records. 📂📈
                      </p>
                    </div>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </div>

      <div
        className={`note-sticky-form ${currentProject ? "d-block" : "d-none"}`}
      >
        <Draggable handle=".modal-headers" cancel=".modal-body">
          <ResizableBox
            width={800}
            style={{
              position: "fixed",
              top: "20%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <Row className="align-items-center justify-content-between">
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img
                    src={editEventImg}
                    alt="Addepe"
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="d-flex gap-2 col-md-12 mb-5 position-relative">
                  <a
                    style={{ position: "absolute", top: 0, right: 0 }}
                    className="modal-headers"
                  >
                    <i
                      className="bi bi-arrows-move cursor-pointer drag-handle"
                      title="Drag Me"
                    ></i>
                  </a>
                  <a className="text-purple pt-2 px-2 rounded work-status cr-status text-center col-md-4">
                    <h5>Working Hours</h5>
                    <h5>
                      {convertMinutesToTimeString(eventDetail?.expectedHours)}{" "}
                      Hrs{" "}
                    </h5>
                  </a>
                  <a className="text-purple pt-2 px-2 rounded work-status cr-status text-center col-md-4">
                    <h5>Total Hours</h5>
                    <h5>
                      {convertMinutesToTimeString(
                        eventDetail?.totalHoursWorked
                      )}{" "}
                      Hrs
                    </h5>
                  </a>
                </div>
                <div className="w-100">
                  {eventDetail?.isLeave == false &&
                  eventDetail?.isHalfDay == false ? (
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                      <span className="text-purple fw-bold">Late Punches</span>{" "}
                      :
                      {eventDetail?.isLatePunch
                        ? `${getTimeDifferenceInMinutes(
                            "09:00",
                            eventDetail?.inTime || "00:00"
                          )} min`
                        : `No Late Punches`}
                    </p>
                  ) : null}
                  {eventDetail?.isHalfDay ? (
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                      <span className="text-purple fw-bold">Half Day</span> :
                      Approved
                    </p>
                  ) : null}
                  {eventDetail?.isLeave ? (
                    <>
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">Leave Type:</span>{" "}
                        {
                          leave_options?.find(
                            obj => obj?.value == eventDetail?.leaveType
                          )?.label
                        }
                      </p>
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Leave Status:
                        </span>{" "}
                        {eventDetail?.leaveStatus || "-"}
                      </p>
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Leave Document:
                        </span>{" "}
                        {eventDetail?.leaveStatus || "-"}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="punch-body mb-2">
                        <table className="table table-bordered mb-0 table ">
                          <thead>
                            <tr>
                              <th className="header time-taken-user">Sr No.</th>
                              <th className="text-center header col-1">
                                Punch In
                              </th>
                              <th className="text-center header col-1">
                                Punch Out
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {punchPair?.map((obj, i) => {
                              return (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td className="text-center">
                                    {obj?.punch_in}
                                  </td>
                                  <td className="text-center">
                                    {obj?.punch_out}
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div
                className="text-end"
                onClick={() => setCurrentProject(false)}
              >
                <button className=" btn ms-md-0 btn-red btn-label">
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            </Row>
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  )
}

export default HrReport
